import { TransferController } from './transfer.controller';
import template from './transfer.html';

export const transferComponent = {
  name: 'transferComponent',
  restrict: 'E',
  template,
  controller: TransferController,
  controllerAs: 'vm',
  bindings: {}
};



// WEBPACK FOOTER //
// ./src/app/components/transfer/transfer.component.js